var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('app-select',_vm._g(_vm._b({attrs:{"placeholder":"Select Timezone","value":_vm.value,"options":_vm.timezones}},'app-select',_vm.$attrs,false),_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }